import React from 'react';
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

const { Search } = Input;

const SearchBar = ({ value, onChange }) => (
  <Search
    placeholder="Поиск воронок и статусов..."
    value={value}
    onChange={(e) => onChange(e.target.value)}
    allowClear
    style={{ 
      borderRadius: '8px'
    }}
    size="middle"
  />
);

export default SearchBar; 